import type { ComponentOverride } from "../types";

export const MuiInputLabel: ComponentOverride<"MuiInputLabel"> = {
  styleOverrides: {
    root: {
      color: "#66666F",
    },
  },
};
